// extracted by mini-css-extract-plugin
module.exports = {"title":"Legend_title__1551x","click":"Legend_click__3-48R","legend":"Legend_legend__3AE9Z"};